import React, { useEffect, useState } from "react";
import "./myAssociations.scss";

import NoOneElement from "../../components/noOneElement/NoOneElement";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import HeaderBar from "../../components/headerBar/HeaderBar";
import AssociationInfoBox from "../../components/associationInfoBox/AssociationInfoBox";
import { Button, Col, Row, Stack } from "react-bootstrap";

import { t } from "i18next";
import { getMyAssociationsWS } from "./api/myAssociationsApi";
import { setGlobalState } from "../../utils/state";
import { isEmpty } from "../../utils/validation";
import { useNavigate } from "react-router-dom";

const MyAssociations = () => {
  const navigate = useNavigate();
  const [listAssociations, setListAssociations] = useState([]);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    getMyAssociationsWS()
      .then((res) => {
        console.log(res);
        setListAssociations(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <>
      <HeaderBar title={t("dashboard.title")} />
      <div className="container-responsive">
        {!isEmpty(listAssociations) ? (
          <div className="container-my-associations">
            <div className="text-wrapper-my-association">
              <div className="title">{t("dashboard.your_association")}</div>
              <div className="subtitle">{t("dashboard.subtitle")}</div>
            </div>

            <Row sm={1} md={1} lg={2} xl={2} className="w-100 g-2">
              {listAssociations.map((item, index) => (
                <Col key={index} className="d-flex justify-content-center ">
                  <AssociationInfoBox
                    name={item.name}
                    id={item.id}
                    image={
                      item.image
                        ? "data:" + item.image_type + ";base64," + item.image
                        : "/no_img.png"
                    }
                    address={item.address}
                    dashboard={true}
                    callback={() => {
                      navigate(`${item.id}`);
                    }}
                  />
                </Col>
              ))}
            </Row>
          </div>
        ) : (
          <NoOneElement
            title={t("common.oops")}
            subtitle={t("my_associations.empty")}
            image="/empty_association.png"
          />
        )}
        <VoidSpace />
      </div>
    </>
  );
};

export default MyAssociations;
